import { useAuth, useAuthModal } from 'contexts'
import { useEffect } from 'react'

type Config = {
  id: unknown
  shouldDisplay: () => boolean
  afterDisplay?: () => void
}

export function useAutomaticShowAuthModal({
  id,
  shouldDisplay,
  afterDisplay,
}: Config) {
  const { user, isLoading: userIsLoading } = useAuth()
  const {
    setConfig: setAuthModalConfig,
    setIsOpen: setAuthModalIsOpen,
    setState: setAuthModalState,
  } = useAuthModal()

  useEffect(() => {
    if (user || userIsLoading) return

    const displayAuthModal = () => {
      const scrollY = window.scrollY
      const maxScrollY = document.body.clientHeight - window.innerHeight
      const scrolled = (scrollY * 100) / maxScrollY

      if (scrolled >= 20) {
        setAuthModalState('register')
        setAuthModalConfig({ closeable: false })
        setAuthModalIsOpen(true)
        window.removeEventListener('scroll', displayAuthModal)
        afterDisplay?.()
      }
    }

    const _shouldDisplay = shouldDisplay()

    if (_shouldDisplay) {
      window.addEventListener('scroll', displayAuthModal)
    }

    return () => {
      window.removeEventListener('scroll', displayAuthModal)
    }
  }, [
    id,
    user,
    userIsLoading,
    shouldDisplay,
    afterDisplay,
    setAuthModalState,
    setAuthModalConfig,
    setAuthModalIsOpen,
  ])
}
